interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ index, eyebrow, title, desc }: SectionHeadingProps) {
  return (
    <div className="max-w-3xl">
      <div className="mb-5 flex items-center gap-3">
        <span className="font-label text-xs tracking-[0.3em] text-primary-600">{index}</span>
        <span className="h-px w-10 bg-primary-300" />
        <span className="font-label text-[11px] uppercase tracking-[0.25em] text-foreground-500">{eyebrow}</span>
      </div>
      <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h2>
      {desc && <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}